export enum CompanyTabs {
    DETAILS = 'details',
    SETTINGS = 'settings',
    COMMUNICATION_PREFERENCES = 'communicationPreferences',
}
